import { createRoot } from 'react-dom/client';
import { Suspense } from 'react';
import './scss/main.scss';
import CommingSoon from './components/seo/CommingSoon';

import App from './components/App';
import i18n from './services/i18n';
import { initWebVitals } from './utils/common/webVitals';
import { initSentry } from './utils/common/sentry';

const BENIGN_ERROR_PATTERNS = [
    /n\.settled/i,
    /reading\s+'settled'/i,
    /evaluating\s+'n\.settled'/i,
    /maximum\s+call\s+stack/i,
    /seek.*undefined/i,
];

const isBenignThirdPartyError = (msg) => {
    if (!msg) return false;
    const text = String(msg);
    return BENIGN_ERROR_PATTERNS.some((re) => re.test(text));
};

window.addEventListener(
    'error',
    (event) => {
        if (isBenignThirdPartyError(event.message)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return false;
        }
        return undefined;
    },
    true,
);

window.addEventListener(
    'unhandledrejection',
    (event) => {
        const reason = event.reason;
        const msg = reason?.message || reason;
        if (isBenignThirdPartyError(msg)) {
            event.preventDefault();
            return false;
        }
        return undefined;
    },
    true,
);

const container = document.getElementById('root');
const root = createRoot(container);

const renderApp = () => {
    root.render(
        <Suspense fallback={<CommingSoon />}>
            <App />
        </Suspense>,
    );
};

if (i18n.isInitialized) {
    renderApp();
} else {
    i18n.on('initialized', renderApp);
}

if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(() => {
        initWebVitals();
        initSentry();
    });
} else {
    setTimeout(() => {
        initWebVitals();
        initSentry();
    }, 0);
}

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js', { scope: '/' })
            .catch(() => {});
    });
}
